/*
 * NewsCard Messages
 *
 * This contains all the text for the NewsCard component.
 */
import { defineMessages } from 'react-intl';

export default defineMessages({
  selectYourLanguage: {
    id: 'app.components.LanguageButton.selectYourLanguage',
    defaultMessage: 'Select your language',
  },
  closeLanguageSelection: {
    id: 'app.components.LanguageButton.closeLanguageSelection',
    defaultMessage: 'Close language selection',
  },
});
